import { NuxtHTTPInstance } from '@nuxt/http';

import apiUrls from '@/apiUrls.config';
import { ILongSEO, IOpinion } from '~/components/szukaj/seo/types/ISeo';
import { ISeoPayload } from '~/types/ISeoPayload';

export const fetchMainDescription = async (http: NuxtHTTPInstance, payload: ISeoPayload): Promise<ILongSEO> => {
  const res: ILongSEO = await http.$post(`${apiUrls.seo}/pobierz`, payload);

  return res;
};

export const fetchOpinie = async (http: NuxtHTTPInstance, panstwo: string, region: string): Promise<IOpinion[]> => {
  const urlBase = 'https://rpl-api.r.pl/opinie/opinie-dla-lokalizacji/info-panstwo-region-opinie';
  const urlQuery = `?nazwaPanstwaUrl=${panstwo}&nazwaRegionuUrl=${region}&dopobrania=10&pobrane=0`;
  const url = urlBase + urlQuery;
  const res: IOpinion[] = await http.$get(url);

  return res;
};
